import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const NewWindow = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="NewWindow" {...props}>
    <path d="M10.2002 2C10.7524 2.00011 11.2002 2.44778 11.2002 3C11.2002 3.55222 10.7524 3.99989 10.2002 4H6.59961C5.16398 4.00021 4.00021 5.16398 4 6.59961V17.4004C4.00021 18.836 5.16398 19.9998 6.59961 20H17.4004C18.836 19.9998 19.9998 18.836 20 17.4004V13.7998C20.0001 13.2476 20.4478 12.7998 21 12.7998C21.5522 12.7998 21.9999 13.2476 22 13.7998V17.4004C21.9998 19.9406 19.9406 21.9998 17.4004 22H6.59961C4.05941 21.9998 2.00021 19.9406 2 17.4004V6.59961C2.00021 4.05941 4.05941 2.00021 6.59961 2H10.2002Z" fill="#000" /><path d="M22 1C22.5523 1 23 1.44772 23 2V9C23 9.55229 22.5523 10 22 10C21.4477 10 21 9.55229 21 9V4.41406L12.707 12.707C12.3165 13.0976 11.6835 13.0976 11.293 12.707C10.9024 12.3165 10.9024 11.6835 11.293 11.293L19.5859 3H15C14.4477 3 14 2.55228 14 2C14 1.44772 14.4477 1 15 1H22Z" fill="#000" />
  </StyledIcon>
));

NewWindow.displayName = 'NewWindow';

export { NewWindow };
